import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faPencil, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { CuentaContableEmpresaReadingDtoProps } from "api/DTOs/CuentaContableEmpresaReadingDto"
import { formatCurrency } from "common/utils/currency"
import { NO_BALANCE } from "constants/numbers"
import { ColoredNumber } from "features/Contabilidad/components/ColoredNumber"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { UUIDType } from "uuid"
import { ShowDelete } from "../CuadroCuentasContables"

export const CUADRO_CUENTAS_COLUMNS = (
  t: TFunction,
  addCuentaEmpresaId: (id: string | UUIDType) => void,
  setShowDelete: Dispatch<SetStateAction<ShowDelete>>
) => {
  const columns = [
    {
      header: `${t("cuadroCuentas.tab.headerAccount")}`,
      key: "numero",
      field: "numero",
      style: { width: "10%" },
      sortable: true,
      sortField: "Numero",
    },
    {
      header: `${t("cuadroCuentas.tab.headerName")}`,
      key: "nombre",
      field: "nombre",
      style: { width: "26%" },
      sortable: true,
      sortField: "Nombre",
    },
    {
      header: `${t("cuadroCuentas.tab.headerGroup")}`,
      key: "grupoNombre",
      field: "grupoNombre",
      style: { width: "20%" },
      sortable: true,
      sortField: "CuentaContable.CuentaContable_SubGrupo.Nombre",
    },
    {
      header: `${t("cuadroCuentas.tab.headerDebit")}`,
      key: "totalDebe",
      field: "totalDebe",
      alignCol: "right",
      bodyClassName: "!tw-text-end ",
      body: ({ totalDebe }: CuentaContableEmpresaReadingDtoProps) =>
        formatCurrency(totalDebe),
      style: { width: "15%" },
    },
    {
      header: `${t("cuadroCuentas.tab.headerCredit")}`,
      key: "totalHaber",
      field: "totalHaber",
      alignCol: "right",
      bodyClassName: "!tw-text-end ",
      body: ({ totalHaber }: CuentaContableEmpresaReadingDtoProps) =>
        formatCurrency(totalHaber),
      style: { width: "15%" },
    },
    {
      header: `${t("cuadroCuentas.tab.headerBalances")}`,
      key: "saldo",
      sorter: false,
      field: "saldo",
      alignCol: "right",
      bodyClassName: "!tw-text-end ",
      body: ({ saldo }: CuentaContableEmpresaReadingDtoProps) =>
        ColoredNumber(saldo ?? 0),
      style: { width: "10%" },
    },
    {
      key: "edit",
      body: (rowData: CuentaContableEmpresaReadingDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: "Editar",
                hasRedirect: true,
                action: () => {
                  rowData.id && addCuentaEmpresaId(rowData.id)
                },
                icon: faPencil,
              },
              {
                title: "Eliminar",
                hasRedirect: true,
                className: "!tw-text-danger",
                show:
                  rowData.totalDebe === NO_BALANCE &&
                  rowData.totalHaber === NO_BALANCE &&
                  !rowData.esBase,
                action: () =>
                  rowData?.id && setShowDelete({ id: rowData?.id, show: true }),
                icon: faTrashCan,
              },
            ]}
            position='right'
          />
        )
      },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      style: { width: "4%" },
    },
  ]
  return columns
}
